export default "/etc.clientlibs/des/cart-checkout/clientlibs/des-cart-checkout/resources/b9dd2f7a21633258eb1a2018f2706da6.png";